

























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import {ExtendedIFTRowElementUnion} from '@/views/formular/form.interface';


/**
 * General Component for Fields of type LIST_TABLE
 */
@Component({
  name: 'AmetrasListTableFieldTemplate',
  components: {FormTemplate: () => import('@/views/formular/FormTemplate.vue')},
  mixins: [BindAttrs]
})
export default class AmetrasListTableFieldTemplate extends Vue {

  @Prop() typeSpecificSettings!: DisguiseDto.TableListFieldSpecificSettingsV2;

  /**
   * as of 09.10.2024: missing impl for FTGridDto
   *
   * this component behaves like a wrapper for an inner formular
   * if the user changes in the inner formular data, the outer formular should be updated.
   *
   * outerFormular: {
   *   AmetrasListTableFieldTemplate: {
   *     innerFormular: {
   *       FormularField 4711
   *     }
   *   }
   * }
   *
   * if the user changes FormularField 4711, innerFormular is informed about a field update internally and publishes
   * the native event using prefix "component:" followed by the native event name (e.g. change).
   * to get informed about the change event of any inner component, we listen for "@content:change" (any other event
   * would be also possible, e.g. "@content:input").
   *
   * after the event has triggered, we have to find the field definition in the array of rows and update the data.
   * in order to inform the outerFormular about the update, we emit update-type-specific-settings
   */
  componentHasChanged(event: {fieldDefinition: ExtendedIFTRowElementUnion, args: any}, cellFormular: DisguiseDto.FTDefinitionDto) {
    if (cellFormular !== undefined && event.fieldDefinition && event.fieldDefinition.type === 'FTFieldDto' && event.fieldDefinition.customReferenceName !== undefined) {
      const fieldReferenceIdx: {[key: string]: DisguiseDto.FTFieldDto} = {};
      for (const currentContent of cellFormular.rows || []) {
        if (currentContent['@type'] === 'FTRowDto') {
          const castedCurrentRow = currentContent as DisguiseDto.FTRowDto;
          for (const currentRowContent of castedCurrentRow.fields || []) {
            if (currentRowContent.type === 'FTFieldDto' && currentRowContent.customReferenceName !== undefined) {
              fieldReferenceIdx[currentRowContent.customReferenceName] = currentRowContent;
            }
          }
        }
      }
      const lookupField = fieldReferenceIdx[event.fieldDefinition.customReferenceName];
      if (lookupField) {
        lookupField.value = event.args;
        this.$emit('update-type-specific-settings', this.typeSpecificSettings);
      }
    }
  }
}
